/**
 * 路線高程外框樣式（主色 = 路線識別，外框色 = 地下/地面/高架）
 */

export const ELEVATION_OUTLINE = {
    underground: '#1565C0',
    elevated: '#E65100',
    at_grade: '#2E7D32',
    unknown: '#9E9E9E'
};

export function getElevationOutlineColor(elevation) {
    return ELEVATION_OUTLINE[elevation] || ELEVATION_OUTLINE.unknown;
}

/**
 * 在 Leaflet 地圖上繪製「外框 + 主線」雙層折線
 * @returns {L.LayerGroup}
 */
export function addElevationOutlinedLine(map, latLngs, mainColor, elevation, options = {}) {
    const outlineColor = getElevationOutlineColor(elevation);
    const outlineWeight = options.outlineWeight ?? 9;
    const mainWeight = options.mainWeight ?? 4.5;
    const opacity = options.opacity ?? 0.88;

    const dashArray = options.dashArray;
    const skipOutline = options.skipOutline === true;
    let renderer = options.renderer;
    if (!renderer && typeof L !== 'undefined' && L.canvas) {
        if (map && map._sovereignLineCanvas) {
            renderer = map._sovereignLineCanvas;
        } else {
            renderer = L.canvas({ padding: 0.5 });
            if (map) map._sovereignLineCanvas = renderer;
        }
    }
    const main = L.polyline(latLngs, {
        color: mainColor,
        weight: mainWeight,
        opacity,
        lineJoin: 'round',
        lineCap: 'round',
        dashArray,
        renderer
    });
    if (skipOutline) {
        const group = L.layerGroup([main]);
        if (options.addTo !== false) group.addTo(map);
        return { group, outline: null, main };
    }
    const outline = L.polyline(latLngs, {
        color: outlineColor,
        weight: outlineWeight,
        opacity,
        lineJoin: 'round',
        lineCap: 'round',
        interactive: false,
        dashArray,
        renderer
    });
    const group = L.layerGroup([outline, main]);
    if (options.addTo !== false) group.addTo(map);
    return { group, outline, main };
}
